export default {
    itemPropertyContextUpdater: {
        contextProperties: [],
        idType: "constantValue",
        idValue: ""
    },
    scriptContextUpdater: {
        script: ""
    },
    userEventItemContextUpdater: {
        eventType: ":1",
        insertedName: "",
        contextProperties: []
    },
    userEventItemMetaContextUpdater: {
        eventType: ":0",
        minSupport: 1,
        contextProperties: []
    }
}
